import { useFormik } from 'formik';
import React, { useState } from 'react';
import { AiFillLock, AiOutlineMail } from 'react-icons/ai';
import { API_URLS } from '../../config/APIUrls';
import CustomCircularProgress from '../../Shared/loder/CustomCircularProgress';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import bg from "../../image/BLO.png"

const LogIn = () => {
  const [loding, setloding] = useState(false);
  const navigate = useNavigate();
  const initialValue = {
    username: '',
    password: '',
  };

  const fk = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    onSubmit: () => {
      const reqBody = {
        username: fk.values.username,
        password: fk.values.password,
      };
      loginFunction(reqBody);
    },
  });

  const loginFunction = async (reqBody) => {
    setloding(true);
    try {
      const response = await axios.post(API_URLS.master_login, reqBody);
      toast(response?.data?.msg);
      if (response?.data?.success) {
        console.log(response?.data?.response?.[0]?.token);
        localStorage.setItem('token', response?.data?.response?.[0]?.token);
        localStorage.setItem('type', response?.data?.response?.[0]?.login_type);
        navigate('/main');
        window.location.reload();

      }
    } catch (e) {
      console.log(e);

    } finally {
      setloding(false);
    }
  };

  //   return (
  //   <div className="min-h-screen flex items-center justify-center bg-[#F3F6FA] px-4">
  //     <CustomCircularProgress isLoading={loding} />

  //     <div className="w-full max-w-md bg-white shadow-lg border border-gray-300 rounded-md">

  //       {/* Header */}
  //       <div className="bg-[#0F4C81] text-white text-center py-4 rounded-t-md">
  //         <h1 className="text-lg font-semibold">
  //           Panchayati Raj Attendance Management
  //         </h1>
  //         <p className="text-xs opacity-90">
  //           Government of India
  //         </p>
  //       </div>

  //       {/* Form */}
  //       <div className="p-6">
  //         <h2 className="text-center text-gray-800 font-semibold mb-6">
  //           Admin / Officer Login
  //         </h2>

  //         <form onSubmit={fk.handleSubmit} className="space-y-5">

  //           {/* Username */}
  //           <div>
  //             <label className="block text-sm font-medium text-gray-700 mb-1">
  //               Username
  //             </label>
  //             <div className="flex items-center border border-gray-300 rounded">
  //               <span className="px-3 text-gray-500">
  //                 <AiOutlineMail size={18} />
  //               </span>
  //               <input
  //                 type="text"
  //                 name="username"
  //                 value={fk.values.username}
  //                 onChange={fk.handleChange}
  //                 placeholder="Enter Username"
  //                 className="w-full px-3 py-2 outline-none text-sm"
  //               />
  //             </div>
  //           </div>

  //           {/* Password */}
  //           <div>
  //             <label className="block text-sm font-medium text-gray-700 mb-1">
  //               Password
  //             </label>
  //             <div className="flex items-center border border-gray-300 rounded">
  //               <span className="px-3 text-gray-500">
  //                 <AiFillLock size={18} />
  //               </span>
  //               <input
  //                 type="password"
  //                 name="password"
  //                 value={fk.values.password}
  //                 onChange={fk.handleChange}
  //                 placeholder="Enter Password"
  //                 className="w-full px-3 py-2 outline-none text-sm"
  //               />
  //             </div>
  //           </div>

  //           {/* Button */}
  //           <button
  //             type="submit"
  //             className="w-full bg-[#0F4C81] hover:bg-[#09345C] text-white py-2 rounded font-semibold text-sm"
  //           >
  //             Login
  //           </button>
  //         </form>

  //         {/* Footer */}
  //         <div className="text-xs text-gray-600 mt-5 text-center">
  //           © Panchayati Raj Department | All Rights Reserved
  //         </div>

  //         <p
  //           className="text-xs text-blue-700 mt-2 text-center cursor-pointer underline"
  //           onClick={() => navigate('/privacy_policy')}
  //         >
  //           Privacy Policy
  //         </p>
  //       </div>
  //     </div>
  //   </div>
  // );

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-8 bg-cover bg-center"
      style={{
        backgroundImage: `url(${bg})`,
      }}
    >
      <CustomCircularProgress isLoading={loding} />

      <div className="bg-blue-700 backdrop-blur-md shadow-xl rounded-xl p-8 py-10 w-full max-w-md border border-white/20 ">
        <h2 className="text-3xl font-bold text-white text-center mb-8 tracking-wide">
          Welcome Back
        </h2>

        <form onSubmit={fk.handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm text-white mb-1 ml-1">
              Username
            </label>
            <div className="flex items-center bg-white/20 border border-white/30 rounded-md overflow-hidden focus-within:ring-2 focus-within:ring-purple-500">
              <input
                type="text"
                name="username"
                value={fk.values.username}
                onChange={fk.handleChange}
                placeholder="Enter your username"
                className="w-full px-4 py-2 bg-transparent text-white placeholder-white/70 outline-none"
              />
              <div className="p-2 text-white/80">
                <AiOutlineMail size={24} />
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm text-white mb-1 ml-1">
              Password
            </label>
            <div className="flex items-center bg-white/20 border border-white/30 rounded-md overflow-hidden focus-within:ring-2 focus-within:ring-purple-500">
              <input
                type="password"
                name="password"
                value={fk.values.password}
                onChange={fk.handleChange}
                placeholder="Enter your password"
                className="w-full px-4 py-2 bg-transparent text-white placeholder-white/70 outline-none"
              />
              <div className="p-2 text-white/80">
                <AiFillLock size={24} />
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-t from-[#1E3C94] to-[#7D85FE] text-white py-2 rounded-full font-semibold shadow-md transition-all duration-200"
          >
            Login Now
          </button>
        </form>

        <p
          className="text-white p-2 mt-2 text-xs text-end cursor-pointer underline"
          onClick={() => navigate('/privacy_policy')}
        >
          Click Here Privacy Policy
        </p>
      </div>
    </div>
  );

};

export default LogIn;
